import React from 'react'
import { NavLink } from 'react-router-dom'

const Discover = () => {
    return (
        <section className='bg__purple'>
            <div className="container">
                <div className="row justify-content-between text-center text-md-left">
                    <div className='col-md-7 mb-4 my-md-auto'>
                        <h2 className='medium font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx color__white'> Eid El Adha Offer!🎉</h2>
                        <p className='normal font__size--16 text__16-1024 color__white mb-0'>Get 50% OFF on all Nutrition plans & Books — start your transformation today before the offer ends! ⚡ </p>
                    </div>
                    <div className='col-md-4 my-auto text-md-right'>
                        <NavLink to="/membership" className='medium font__size--14 text__14-1024 btn btn__white shadow color__black rounded__50'>Get Started</NavLink>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Discover